import { Sparkles } from 'lucide-react';
import {
  TRIAL_END_LABEL,
  TRIAL_RENEWAL_LABEL,
  TRIAL_TENANT_NAME,
  getTrialStatus,
} from './trial';

/**
 * Persistent trial-status banner for the home screen.
 *
 * Deliberately not dismissible — the contractual end-date and the
 * single-user scope are facts the operator (and any auditor reviewing
 * the device) should see every time they open the app, not buried
 * behind a "ok don't show again" once-tap state.
 *
 * Renders nothing once the trial has expired — at that point the
 * PwaTrialGate has taken over and the operator is looking at the
 * expiry screen, so a banner would be redundant.
 */
export function PwaTrialBanner() {
  const status = getTrialStatus();
  if (status.expired) return null;

  const daysLine =
    status.daysRemaining === 0
      ? 'Final day of trial.'
      : status.daysRemaining === 1
        ? '1 day left in trial.'
        : `${status.daysRemaining} days left in trial.`;

  return (
    <div
      role="status"
      aria-live="polite"
      className="mb-4 overflow-hidden rounded-2xl border border-primary/30 bg-gradient-to-br from-primary/15 via-primary/5 to-transparent p-3.5"
    >
      <div className="flex items-start gap-3">
        <div className="grid h-9 w-9 shrink-0 place-items-center rounded-xl bg-primary text-primary-foreground shadow-sm">
          <Sparkles className="h-4 w-4" />
        </div>
        <div className="min-w-0 flex-1 space-y-1">
          <div className="flex flex-wrap items-baseline gap-x-2">
            <span className="text-[12.5px] font-semibold text-foreground">
              Beta · {TRIAL_TENANT_NAME}
            </span>
            <span className="text-[11px] font-medium text-primary">
              {daysLine}
            </span>
          </div>
          <p className="text-[11.5px] leading-snug text-muted-foreground">
            Single-user access. Valid until <strong className="text-foreground">{TRIAL_END_LABEL}</strong>.
            An active subscription is required from <strong className="text-foreground">{TRIAL_RENEWAL_LABEL}</strong> onwards.
          </p>
        </div>
      </div>
    </div>
  );
}
